import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PremiumTeaser from "./PremiumTeaser";

// Every tool route gets the 20-Year Report promo above the footer. If the page is
// already showing its own PremiumTeaser (e.g. Kundali after results), we hide ours.
const TOOL_PATHS = new Set([
  "/compatibility", "/dasha", "/horoscope", "/kundali-calculator", "/marriage-muhurat",
  "/name-numerology", "/tools/celebrity-lookalike",
  "/ashtakavarga", "/astro-gps", "/bhrigu-bindu", "/celebrities", "/chakras", "/divisional-charts",
  "/doshas", "/ishta-devata", "/kalachakra-dasha", "/kp-astrology", "/life-replay", "/muhurat",
  "/nakshatra", "/navamsa", "/numerology-deep", "/past-life", "/planet-effects", "/rahu-placement",
  "/raja-yogas", "/rashi-tulya-navamsa", "/rudramsha", "/saptavimshamsha", "/tools/baby-muhurat",
  "/tools/celebrity-pattern-recognizer", "/tools/pushkar", "/varshaphal", "/visualise",
  "/astro-visualization", "/wealth-hora", "/wealth-programming", "/tools",
]);

export default function ToolReportPromo() {
  const { pathname } = useLocation();
  const path = pathname.replace(/\/+$/, "") || "/";
  const isTool = TOOL_PATHS.has(path);
  const [pageHasOwn, setPageHasOwn] = useState(false);
  useEffect(() => {
    if (!isTool) return undefined;
    const check = () => setPageHasOwn(!!document.querySelector('[data-testid$="premium-teaser"]:not([data-testid="tool-premium-teaser"])'));
    check();
    const mo = new MutationObserver(check);
    mo.observe(document.body, { childList: true, subtree: true });
    return () => mo.disconnect();
  }, [isTool, path]);
  if (!isTool || pageHasOwn) return null;
  return (
    <section className="max-w-6xl mx-auto px-5 sm:px-6 lg:px-10 pb-16" data-testid="tool-twenty-year-promo">
      <PremiumTeaser
        testid="tool-premium-teaser"
        topLine={
          <>
            This tool shows one slice of your chart. Your 20-year report shows the whole story.
            <br />
            <span className="text-amber-300">Unlock 55+ pages of what&apos;s next.</span>
          </>
        }
        subLine={
          <>
            Your lagna and current dasha set the direction. The full 20-year Vedic timeline decodes your
            Sade Sati window, 6 doshas, gem &amp; rudraksha recommendations, and year-by-year career,
            marriage, wealth and health scores.
          </>
        }
      />
    </section>
  );
}
